/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:46:31
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-06-20 22:18:47
 */
import { ConstructorOptions, ListenerFn, EventEmitter2 as EventEmitter } from 'eventemitter2';

export const EVENTS = {
  // userLogin: 'user-login',
  // userLogout: 'user-logout',
  userLogin: 'Market.UserLogin', // 改名，和tgbApi保持一致
  userLogout: 'Market.UserLogout', // 改名，和tgbApi保持一致
  switchIn: 'switch-in',
  switchInShow: 'switch-in-show',
  switchOut: 'switch-out',
  switchOutShow: 'switch-out-show',
  checkShowOnScroll: 'check-show-on-scroll', // 滚动的时候检查是否显示

  // reloadLaunchGames: 'reload-launch-games', // 通知重新加载启动游戏历史

  perfectScrollbarSetScrollTop: 'perfect-scrollbar-set-scrollTop', // 设置滚动条
  perfectScrollbarUpdate: 'perfect-scrollbar-update', // 滚动条更新
  perfectScrollbarPsYReachEnd: 'perfect-scrollbar-ps-y-reach-end', // 滚动条到底

  wrapperScrollDown: 'wrapper-scroll-down', // 滚动条向下滚动

  showBafuIntroduction: 'show-bafu-introduction', // 展示霸服规则弹窗
  showBafuPrivilege: 'show-bafu-privilege', // 展示霸服特权详情弹窗
  showBafuQa: 'show-bafu-qa', // 展示霸服常见问题
  showBafuHistory: 'show-bafu-history', // 展示领取记录
  bafuHistoryCopy: 'bafu-history-copy', // 领奖记录复制cdkey
  showBafuGiftDetail: 'show-bafu-gift-detail', // 展示礼包详情弹窗
  setBafuCurDialog: 'set-bafu-cur-dialog', // 设置顶层弹窗
  showBafuUnlockDialog: 'show-bafu-unlock-dialog', // 展示解锁弹窗
  showBafuCdkeyDialog: 'show-bafu-cdkey-dialog', // 展示cdkey弹窗
  showBafuAreaDialog: 'show-bafu-area-dialog', // 展示选区服弹窗
  hideBafuAreaDialog: 'hide-bafu-area-dialog', // 隐藏选区服弹窗
  recommendSubCategoryLoaded: 'recommendSubCategoryLoaded', // 推荐页子菜单加载完毕
};

export { Listener } from 'eventemitter2';
/**
 * 判断一个事件的名称是否符合规则
 * @param event 事件名
 * @returns 判断结果
 */
function validateOneEvent(event: string) {
  // 事件名不能为空
  if (!event) return false;
  // 事件名不能以点号开头或结尾
  if (event.startsWith('.') || event.endsWith('.')) return false;
  return true;
}

/**
 * 格式化事件名
 * @param event 事件名
 * @returns 格式化后的事件名
 */
function formatOneEvent(event: string) {
  return event.toLowerCase();
}

/**
 * Nutty事件处理器类，使用了第三方的类库EventEmitter2
 */
export class EventHandler {
  /** EventEmitter2实例 */
  private eventEmitter: EventEmitter;
  /** 构造函数初始化EventEmitter */
  constructor() {
    const options: ConstructorOptions = {
      wildcard: true, // 支持 * 表示通配
      maxListeners: 0, // 默认不限制listener的个数
    };
    this.eventEmitter = new EventEmitter(options);
  }

  /**
   * 获取EventEmitter实例，暴露高级用法
   * @returns EventEmitter实例
   */
  getInstance() {
    return this.eventEmitter;
  }

  /**
   * 监听一个事件
   * @param event 事件名
   * @param listener 监听回调函数
   * @returns 处理器实例本身
   */
  $on(event: string, listener: ListenerFn) {
    // 事件名不符合规则直接抛错
    if (!validateOneEvent(event)) {
      throw new Error('事件名不符合规则');
    }

    this.eventEmitter.on(formatOneEvent(event), listener);
    return this;
  }

  /**
   * 监听一个事件一次，触发后移除监听器
   * @param event 事件名
   * @param listener 监听回调函数
   * @returns 处理器实例本身
   */
  $once(event: string, listener: ListenerFn) {
    // 事件名不符合规则直接抛错
    if (!validateOneEvent(event)) {
      throw new Error('事件名不符合规则');
    }

    this.eventEmitter.once(formatOneEvent(event), listener);
    return this;
  }

  /**
   * 触发一个事件
   * @param event 事件名
   * @param values 传值
   * @returns 触发结果
   */
  $emit(event: string, ...values: any[]) {
    // 事件名不符合规则直接抛错
    if (!validateOneEvent(event)) {
      throw new Error('事件名不符合规则');
    }

    // 监听回调函数的第一个参数是事件全名
    return this.eventEmitter.emit(formatOneEvent(event), ...values);
  }

  /**
   *  移除一个事件上的一个/所有监听器
   * @param event 事件名
   * @param listener 要移除的监听器
   * @returns 处理器实例本身
   */
  $off(event: string, listener?: ListenerFn) {
    // 事件名不符合规则直接抛错
    if (!validateOneEvent(event)) {
      throw new Error('事件名不符合规则');
    }

    // 如果没有传入监听回调函数，移除所有监听器
    if (!listener) {
      this.eventEmitter.removeAllListeners(formatOneEvent(event));
      return this;
    }

    // 如果传入了监听回调函数，只需移除事件对应的该监听器
    this.eventEmitter.off(formatOneEvent(event), listener);
    return this;
  }
}

export const tgbEventBus = new EventHandler();
